import { useCallback } from 'react';

import { AnalyticsEvent, useAnalytics } from '@bonusly/analytics';

export interface CompleteClaimRewardEventProps {
	categories: string;
	giftEmail?: string;
	isGift?: 'Yes' | 'No';
	isGiftable?: 'Yes' | 'No';
	price: string;
	result: 'Success' | 'Failure';
	rewardName: string;
}
export interface ComfirmClaimRewardClickEventProps {
	categories: string;
	giftEmail?: string;
	isGift?: 'Yes' | 'No';
	isGiftable?: 'Yes' | 'No';
	price: string;
	rewardName: string;
}
export interface HomeRecommendedRewardClickEventProps {
	rewardName: string;
	categories: string;
	recommendedReason: 'promoted' | 'personal_recommendation' | '';
}

export interface RewardCategoryClickEventProps {
	categoryName: string;
}

export interface RewardNavigationEventProps {
	pathway: 'menu' | 'shop_reward_cta';
}

export interface RewardTileClickEventProps {
	categories: string;
	rewardName: string;
	previouslyClaimed: boolean;
}

export const useRewardAnalytics = () => {
	const { track } = useAnalytics();

	const trackCompleteClaimReward = useCallback(
		(eventProps: CompleteClaimRewardEventProps) => {
			track(AnalyticsEvent.Rewards.CompleteClaimReward, {
				...eventProps,
			});
		},
		[track]
	);

	const trackConfirmClaimRewardClick = useCallback(
		(eventProps: ComfirmClaimRewardClickEventProps) => {
			track(AnalyticsEvent.Rewards.ConfirmClaimRewardClick, {
				...eventProps,
			});
		},
		[track]
	);

	const trackHomeRecommendedRewardClick = useCallback(
		(eventProps: HomeRecommendedRewardClickEventProps) => {
			track(AnalyticsEvent.Rewards.HomeRecommendedRewardClick, {
				...eventProps,
			});
		},
		[track]
	);

	const trackRewardCategoryClick = useCallback(
		(eventProps: RewardCategoryClickEventProps) => {
			track(AnalyticsEvent.Rewards.RewardCategoryClick, {
				...eventProps,
			});
		},
		[track]
	);

	const trackRewardHistoryClick = useCallback(() => {
		track(AnalyticsEvent.Rewards.RewardHistoryClick);
	}, [track]);

	const trackRewardNavigation = useCallback(
		(eventProps: RewardNavigationEventProps) => {
			track(AnalyticsEvent.Rewards.RewardNavigation, {
				...eventProps,
			});
		},
		[track]
	);

	const trackRewardTileClick = useCallback(
		(eventProps: RewardTileClickEventProps) => {
			track(AnalyticsEvent.Rewards.RewardTileClick, {
				...eventProps,
			});
		},
		[track]
	);

	return {
		trackCompleteClaimReward,
		trackConfirmClaimRewardClick,
		trackHomeRecommendedRewardClick,
		trackRewardCategoryClick,
		trackRewardHistoryClick,
		trackRewardNavigation,
		trackRewardTileClick,
	};
};
